export default "__VITE_ASSET__BAdfnmYt__"